import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/layout/AdminLayout';
import BlockForm from '../../components/admin/BlockForm';
import blocksApi from "../../components/admin/blocksApi";
import toast from "react-hot-toast";

const AdminCreateBlock = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      console.log('Creating block with data:', data);

      const payload = {
        title: data.title,
        identifier: data.identifier,
        content: data.content,
        isActive: data.isActive,
      };

      console.log('Creating block with payload:', payload);
      
      const response = await blocksApi.createBlock(payload);
      
      console.log('Create response:', response);
      toast.success("Block created successfully!");
      
      // Navigate back to blocks list
      navigate("/admin/blocks");
    } catch (error) {
      console.error("Error creating block:", error);
      
      // Handle specific error messages
      if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Failed to create block");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout>
      <BlockForm
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        title="Create New Block"
        submitButtonText="Create Block"
      />
    </AdminLayout>
  );
};

export default AdminCreateBlock;
